import script from "./VideoPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoPreview.vue?vue&type=script&setup=true&lang=ts"

import "./VideoPreview.vue?vue&type=style&index=0&id=786a5850&lang=scss&scoped=true"
import "./VideoPreview.vue?vue&type=style&index=1&id=786a5850&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786a5850"]])

export default __exports__